import Vue from 'vue'

import Moment from 'moment'
import { extendMoment } from 'moment-range'

Vue.use(require('vue-moment'))

export const moment = extendMoment(Moment)
